"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const isFromEu_1 = __importDefault(require("./isFromEu"));
/**
 * @param client Invoice client
 * @returns Whether the Invoice/Quote benefits from VAT exemption or not
 */
const shouldBeExemptedFromVAT = (client) => {
    const { country, vatId } = client;
    // client should be an organization
    if (client.type !== 'ORGANIZATION') {
        return false;
    }
    // If the client's country is defined & is from outside the EU
    let isOutsideEU = !!country && !(0, isFromEu_1.default)(country);
    // Fallback on VAT ID as VAT IDs can be more accurate than clients' country
    if (isOutsideEU && vatId) {
        isOutsideEU = !(0, isFromEu_1.default)(vatId.slice(0, 2).toUpperCase());
    }
    return isOutsideEU;
};
exports.default = shouldBeExemptedFromVAT;
